import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import CalculatedOneXTwoFromScoresModel from "../Models/Helpers/CalculatedOneXTwoFromScoresModel";
import TopCorrectScoresModel from "../Models/Helpers/TopCorrectScoresModel";
import MatchSummaryModel from "../Models/Summary/MatchSummaryModel";
import PredictorHelpersValidator from "./PredictorHelpersValidator";

export default class PredictorHelpers {
  private validator: PredictorHelpersValidator = null;

  constructor(config: SDKConfigurationModel) {
    this.validator = new PredictorHelpersValidator(config);
  }

  public calculateOneXTwoFromScores = (
    matchSummary: MatchSummaryModel
  ): CalculatedOneXTwoFromScoresModel => {
    this.validator.validateMatchSummary(matchSummary);
    const { correctScore, correctScoreAdvanced } = matchSummary.predictions;
    const allPredictions = { ...correctScore, ...correctScoreAdvanced };

    let totalPredictions = 0;
    let homePredictions = 0;
    let drawPredictions = 0;
    let awayPredictions = 0;

    Object.entries(allPredictions).forEach(([score, count]) => {
      if (count === 0) return;

      const countPredictions = count as number;
      totalPredictions += countPredictions;
      const [home, away] = score.split(":").map(Number);

      if (home > away) homePredictions += countPredictions;
      else if (home === away) drawPredictions += countPredictions;
      else awayPredictions += countPredictions;
    });

    return {
      home: totalPredictions
        ? Math.round((homePredictions / totalPredictions) * 100)
        : 0,
      draw: totalPredictions
        ? Math.round((drawPredictions / totalPredictions) * 100)
        : 0,
      away: totalPredictions
        ? Math.round((awayPredictions / totalPredictions) * 100)
        : 0,
    };
  };

  public getTopCorrectScores = (
    matchSummary: MatchSummaryModel
  ): TopCorrectScoresModel[] => {
    this.validator.validateMatchSummary(matchSummary);
    const { correctScore, correctScoreAdvanced } = matchSummary.predictions;
    const allPredictions = { ...correctScore, ...correctScoreAdvanced };
    let totalPredictions = 0;
    Object.values(allPredictions).forEach((count: number) => {
      totalPredictions += count;
    });

    return Object.entries(allPredictions)
      .filter(([_, count]) => (count as number) > 0)
      .map(([score, count]) => ({
        score,
        percentage: Math.round(((count as number) / totalPredictions) * 100),
      }))
      .sort((a, b) => b.percentage - a.percentage)
      .slice(0, 3);
  };
}
